import React from 'react'
import { Input } from 'antd'

import { FormErrorMessage } from 'components/reusables/formErrorMessage'
import { FormHelperMessage } from 'components/reusables/formHelperMessage'
import { RequiredFieldLabel } from 'components/reusables/requiredFieldLabel'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import { Field, InputWrapper } from './styled'

interface CourseNameInputProps {
  value: string
  onChange: (value: string) => void
  error?: string
  disabled?: boolean
  normative?: boolean
}

export const CourseNameInput: React.FC<CourseNameInputProps> = ({
  value,
  onChange,
  error = '',
  disabled = false,
  normative = false,
}) => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.courseFields.name`,
  })

  return (
    <Field>
      <RequiredFieldLabel required>{t('label')}</RequiredFieldLabel>
      <InputWrapper $hasError={!!error}>
        <Input
          name="name"
          value={value}
          placeholder={t('placeholder')}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        />
      </InputWrapper>
      {error ? (
        <FormErrorMessage message={error} />
      ) : normative ? (
        <FormHelperMessage message={t('helper')} />
      ) : null}
    </Field>
  )
}
